export const SRE_AI_PARTNERS_LINK = "https://sre-ai-partners.co.jp/";